import styled from 'styled-components'

import { ResponsiveImage, TypeStyle, focusOutline } from '@syconium/little-miss-figgy'

const PreviewItemWidth = 164

const baseSpacingPixelValue = 4

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${({ theme }) => theme.spacing(2)};
`

export const Input = styled.input`
  position: absolute;
  opacity: 0;
`

export const Container = styled.div`
  height: ${PreviewItemWidth}px;
  width: ${PreviewItemWidth}px;
  background-color: ${({ theme }) => theme.color.deprecated.stoneLighter};
  position: relative;
  display: flex;
  justify-content: center;
  border-radius: ${({ theme }) => theme.spacing(1)};
  border: 2px solid transparent;
  &:has(${Input}:checked) {
    border-color: ${({ theme }) => theme.color.deprecated.obsidian};
  }

  ${focusOutline};
  &:focus-within {
    outline-style: solid;
  }
`

export const Label = styled.label`
  ${TypeStyle.css.bodyLarge}
  position: relative;
  height: ${PreviewItemWidth - baseSpacingPixelValue * 4}px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${({ theme }) => theme.spacing(2)};
  cursor: pointer;
  line-height: 24px;

  &:has(${Input}:disabled) {
    cursor: not-allowed;
  }
`

export const Image = styled(ResponsiveImage)<{ opaque?: boolean }>`
  object-fit: contain;
  max-width: 100%;
  max-height: 100%;
  opacity: ${({ opaque }) => (opaque ? 0.5 : 1)};
`
export const Status = styled.div`
  position: absolute;
  text-transform: uppercase;
  font-weight: 600;
  font-size: ${({ theme }) => theme.spacing(2)};
  padding: ${({ theme }) => theme.spacing(2)};
  text-align: center;
  letter-spacing: 0.8px;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgb(255, 255, 255, 0.5);
`

export const EditIcon = styled.button`
  height: ${({ theme }) => theme.spacing(8)};
  width: ${({ theme }) => theme.spacing(8)};
  padding: ${({ theme }) => theme.spacing(2)};
  line-height: ${({ theme }) => theme.spacing(2)};
  border-radius: 50px;
  position: absolute;
  right: ${({ theme }) => theme.spacing(2)};
  top: ${({ theme }) => theme.spacing(2)};
  ${o => o.theme.color.button.secondary.fill.on};
`
